import { render, staticRenderFns } from "./SuccessModal.vue?vue&type=template&id=6bd9dcbe&scoped=true"
import script from "./SuccessModal.vue?vue&type=script&lang=js"
export * from "./SuccessModal.vue?vue&type=script&lang=js"
import style0 from "./SuccessModal.vue?vue&type=style&index=0&id=6bd9dcbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd9dcbe",
  null
  
)

export default component.exports